var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "text-banner", class: { smaller: _vm.smaller } },
        [
          _c(
            "div",
            { staticClass: "content-wrapper h-100 position-relative" },
            [
              _c("img", { attrs: { src: _vm.src, alt: _vm.alt } }),
              _vm._v(" "),
              _c("div", { staticClass: "container position-relative" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-container",
                    attrs: { id: "herotextcontainer" }
                  },
                  [
                    _vm.subText
                      ? _c("h2", {
                          staticClass:
                            "text-white text font-weight-light mb-n12",
                          domProps: { innerHTML: _vm._s(_vm.subText) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.scaleText == true
                      ? _c("h1", {
                          directives: [
                            {
                              name: "resize-text",
                              rawName: "v-resize-text",
                              value: { maxFontSize: "200px" },
                              expression: "{maxFontSize: '200px'}"
                            }
                          ],
                          staticClass: "text-white text",
                          attrs: { id: "textbannertitle" },
                          domProps: { innerHTML: _vm._s(_vm.text) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.scaleText == false
                      ? _c("h1", {
                          staticClass: "text-white text",
                          attrs: { id: "textbannertitle" },
                          domProps: { innerHTML: _vm._s(_vm.text) }
                        })
                      : _vm._e()
                  ]
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }